import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _accessStaffMemberRequest = {};
var _accessStaffMemberResponse = { staffMember: '_staffMember' };
var _createStaffMemberRequest = { staffMember: '_staffMember' };
var _createStaffMemberResponse = { staffMember: '_staffMember' };
var _deleteStaffMemberRequest = {};
var _deleteStaffMemberResponse = {};
var _getStaffMemberRequest = {};
var _getStaffMemberResponse = { staffMember: '_staffMember' };
var _joinStaffMemberRequest = {};
var _joinStaffMemberResponse = { staffMember: '_staffMember' };
var _queryStaffMembersRequest = {};
var _queryStaffMembersResponse = { staffMembers: '_staffMember' };
var _staffMember = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateStaffMemberRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    staffMember: '_staffMember',
};
var _updateStaffMemberResponse = { staffMember: '_staffMember' };
function resolveWixEventsStaffmembersV1StaffMemberManagementUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/events-staff-members',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/events-staff-members',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/events-staff-members',
                destPath: '',
            },
            {
                srcPath: '/_api/events-staff-members',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a staff member. */
export function createStaffMember(payload) {
    var _a = serializer(_createStaffMemberRequest, { _staffMember: _staffMember }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createStaffMemberResponse, {
        _staffMember: _staffMember,
    }).fromJSON;
    function __createStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.staffmembers.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.events.staffmembers.v1.StaffMemberManagement.CreateStaffMember',
            url: resolveWixEventsStaffmembersV1StaffMemberManagementUrl({
                protoPath: '/v1/events-staff-members',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createStaffMember.fromReq = fromReq;
    __createStaffMember.__isAmbassador = true;
    return __createStaffMember;
}
/** Retrieves a staff member. */
export function getStaffMember(payload) {
    var _a = serializer(_getStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStaffMemberResponse, {
        _staffMember: _staffMember,
    }).fromJSON;
    function __getStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.staffmembers.v1.staff_member',
            method: 'GET',
            methodFqn: 'wix.events.staffmembers.v1.StaffMemberManagement.GetStaffMember',
            url: resolveWixEventsStaffmembersV1StaffMemberManagementUrl({
                protoPath: '/v1/events-staff-members/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStaffMember.fromReq = fromReq;
    __getStaffMember.__isAmbassador = true;
    return __getStaffMember;
}
/**
 * Updates a staff member.
 *
 * Each time the staff member is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the staff member.
 * This ensures you're working with the latest staff member
 * and prevents unintended overwrites.
 */
export function updateStaffMember(payload) {
    var _a = serializer(_updateStaffMemberRequest, { _staffMember: _staffMember }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStaffMemberResponse, {
        _staffMember: _staffMember,
    }).fromJSON;
    function __updateStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.staffmembers.v1.staff_member',
            method: 'PATCH',
            methodFqn: 'wix.events.staffmembers.v1.StaffMemberManagement.UpdateStaffMember',
            url: resolveWixEventsStaffmembersV1StaffMemberManagementUrl({
                protoPath: '/v1/events-staff-members/{staffMember.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStaffMember.fromReq = fromReq;
    __updateStaffMember.__isAmbassador = true;
    return __updateStaffMember;
}
/**
 * Deletes a staff member.
 *
 * Deleting a staff member permanently removes them from the staff member List.
 */
export function deleteStaffMember(payload) {
    var _a = serializer(_deleteStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteStaffMemberResponse, {}).fromJSON;
    function __deleteStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.staffmembers.v1.staff_member',
            method: 'DELETE',
            methodFqn: 'wix.events.staffmembers.v1.StaffMemberManagement.DeleteStaffMember',
            url: resolveWixEventsStaffmembersV1StaffMemberManagementUrl({
                protoPath: '/v1/events-staff-members/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteStaffMember.fromReq = fromReq;
    __deleteStaffMember.__isAmbassador = true;
    return __deleteStaffMember;
}
/** Retrieves a list of staff members, given the provided paging, filtering, and sorting. */
export function queryStaffMembers(payload) {
    var _a = serializer(_queryStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStaffMembersResponse, {
        _staffMember: _staffMember,
    }).fromJSON;
    function __queryStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.staffmembers.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.events.staffmembers.v1.StaffMemberManagement.QueryStaffMembers',
            url: resolveWixEventsStaffmembersV1StaffMemberManagementUrl({
                protoPath: '/v1/events-staff-members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStaffMembers.fromReq = fromReq;
    __queryStaffMembers.__isAmbassador = true;
    return __queryStaffMembers;
}
/** Joins as staff member if he's not in suspended status via provided token. */
export function joinStaffMember(payload) {
    var _a = serializer(_joinStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_joinStaffMemberResponse, {
        _staffMember: _staffMember,
    }).fromJSON;
    function __joinStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.staffmembers.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.events.staffmembers.v1.StaffMemberManagement.JoinStaffMember',
            url: resolveWixEventsStaffmembersV1StaffMemberManagementUrl({
                protoPath: '/v1/events-staff-members/join',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __joinStaffMember.fromReq = fromReq;
    __joinStaffMember.__isAmbassador = true;
    return __joinStaffMember;
}
/** Retrieves a staff by access token. */
export function accessStaffMember(payload) {
    var _a = serializer(_accessStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accessStaffMemberResponse, {
        _staffMember: _staffMember,
    }).fromJSON;
    function __accessStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.staffmembers.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.events.staffmembers.v1.StaffMemberManagement.AccessStaffMember',
            url: resolveWixEventsStaffmembersV1StaffMemberManagementUrl({
                protoPath: '/v1/events-staff-members/access',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __accessStaffMember.fromReq = fromReq;
    __accessStaffMember.__isAmbassador = true;
    return __accessStaffMember;
}
//# sourceMappingURL=http.impl.js.map